// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import loginReducer from '../components/commonPages/login/LoginSlice';

export const store = configureStore({
  reducer: {
    login: loginReducer,
  },
});
